import type { ReactNode } from 'react';

export function SectionHeading({
  id,
  eyebrow,
  title,
  description,
  align = 'center',
}: {
  id: string;
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  align?: 'center' | 'left';
}) {
  return (
    <div
      className={
        align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'
      }
    >
      {eyebrow && (
        <p className='mb-4 font-mono text-[11px] font-medium tracking-[0.14em] text-azure-595 uppercase sm:text-xs'>
          {eyebrow}
        </p>
      )}
      <h2
        className='text-[32px] leading-[1.05] font-semibold tracking-[-0.04em] text-balance text-(--v2-text-primary) sm:text-5xl'
        id={id}
      >
        {title}
      </h2>
      {description && (
        <p className='mt-4 text-base leading-relaxed text-pretty text-(--v2-chip-text) sm:mt-5 sm:text-lg'>
          {description}
        </p>
      )}
    </div>
  );
}
